// extracted by mini-css-extract-plugin
export default {"root":"DemoData_root__42kgY","demoTemplate":"DemoData_demoTemplate__RLjIJ"};